import getOcTheme from '../../../theme/services/getOcTheme';

const { palette, spacing } = getOcTheme();

export default {
  '& blockquote': {
    margin: spacing(1),
    paddingLeft: spacing(2),
    borderLeft: `3px solid ${palette.layout.line.divider}`,
    overflow: 'auto',
  },
};
